<template>
    <div class="CaseFileChapterSections">
        <Vuetable :fields="SectionTableOptions.Fields"
                  :data="Sections"
                  pagination-path=""
                  :api-mode="false"
                  :detail-row-component="CaseFileSectionDocumentsObj"
                  track-by="SectionName"
                  ref="sectiontable"
                  row-class="row-section"
                  @vuetable:cell-clicked="OnCellClicked">


            <template slot="Actions" scope="props">
                <div class="horizontal-icons-padded">
                    <span><font-awesome-icon :icon="['fa', 'eye']" v-on:click="ViewGroupedDocument(props.rowData.ChartID, props.rowData.ChapterName, props.rowData.SectionName)" class="pointer" /></span>
                </div>
            </template>
        </Vuetable>
        <DocumentViewer ref="document-viewer-modal-component" />
    </div>
</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faEdit } from '@fortawesome/free-solid-svg-icons';
    //library.add(faEdit);

    import DocumentViewer from "./DocumentViewer.vue";
    import CaseFileSectionDocuments from "./CaseFileSectionDocuments.vue";
    import Vuetable from 'vuetable-2/src/components/Vuetable'

    export default {
        name: "CaseFileChapterSections",
        props: {
            rowData: {
                type: Object,
                required: true
            },
            rowIndex: {
                type: Number
            },
            ChartRecordId: {
                type: String
            },
            options: {
                type: Object,
            }
        },
        data: function () {
            return {
                rowDataSet: {},
                SectionTableOptions: {
                    Fields: [
                        {
                            name: 'SectionLabel',
                            title: '',
                            titleClass: 'section-header',
                        },
                        {
                            name: 'DocCount',
                            title: "",
                            titleClass: 'section-header',
                            callback: 'AppendTextToInt| Document| Documents'
                        },
                        {
                            name: '__slot:Actions',
                            title: '',
                            titleClass: 'section-header',
                            dataClass: 'right-aligned',
                        }
                    ]
                },
                CaseFileSectionDocumentsObj: CaseFileSectionDocuments
            }
        },
        methods: {
            OnCellClicked(data, field, event) {   
                let vm = this;
                this.$refs.sectiontable.toggleDetailRow(data.SectionName);

                setTimeout(function () {
                    vm.Sections.forEach(function (item) {
                        if (item.SectionName != data.SectionName) {
                            vm.$refs.sectiontable.hideDetailRow(item.SectionName);
                        }
                    });
                }, 150);
            },
            AppendTextToInt(inputInt, singularString, pluralString) {
                if (inputInt == 1 || inputInt == -1) {
                    return inputInt + singularString;
                } else {
                    return inputInt + pluralString;
                }
            },
            ViewGroupedDocument(chartID, chapterName, sectionName) {
                this.$refs['document-viewer-modal-component'].ShowViewerModalWithGroupedDocs(chartID, chapterName, sectionName);
            },
            
        },
        components: {
            DocumentViewer,
            Vuetable,
            CaseFileSectionDocuments
        },
        computed: {
            Sections: function () {
                return this.rowData.Sections;
            },
        },
        mounted: function () {
            let vm = this;
            setTimeout(function () {
                vm.$refs.sectiontable.setData(vm.Sections);
            }, 150);
        }
    }
</script>

<style scoped>
    /deep/ .row-section {
        
        background-color: lightgray;
        color: black;
        text-transform: uppercase;
        cursor: pointer;
    }
    table {
        table-layout:fixed;
    }
    .section-header {

    }
    /deep/ .right-aligned {
        text-align: right;
    }
</style>